
export type GetTweetFeedType = typeof GetTweetFeedType[keyof typeof GetTweetFeedType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTweetFeedType = {
  HOME: 'HOME',
  USER: 'USER',
  HASHTAG: 'HASHTAG',
  MENTIONS: 'MENTIONS',
} as const;
